export const BcfRestApi = "https://github.com/opf/openproject/blob/dev/docs/api/bcf/bcf-rest-api.md";
